// src/components/BottomNav.js
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      name: "Home",
      path: "/dashboard",
      icon: (active) => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? "#38bdf8" : "#6b7280"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9,22 9,12 15,12 15,22" />
        </svg>
      ),
    },
    {
      name: "Cards",
      path: "/cards",
      icon: (active) => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? "#38bdf8" : "#6b7280"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
          <line x1="1" y1="10" x2="23" y2="10" />
        </svg>
      ),
    },
    {
      name: "History",
      path: "/history",
      icon: (active) => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? "#38bdf8" : "#6b7280"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12,6 12,12 16,14" />
        </svg>
      ),
    },
    {
      name: "Profile",
      path: "/profile",
      icon: (active) => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={active ? "#38bdf8" : "#6b7280"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
    },
  ];

  // Don't show on public pages
  const hideOn = ["/", "/home", "/login", "/register", "/admin-login", "/payment-success", "/about-us"];
  if (hideOn.includes(location.pathname)) return null;

  // Don't show on admin pages
  if (location.pathname.startsWith("/admin")) return null;

  const isActive = (path) => {
    if (path === "/dashboard") {
      return location.pathname.startsWith("/dashboard");
    }
    return location.pathname === path;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black/90 backdrop-blur-lg border-t border-white/10 z-50">
      <div className="flex justify-around items-center py-2">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => navigate(tab.path)}
            className="flex flex-col items-center py-1 px-3 min-w-[60px]"
          >
            {tab.icon(isActive(tab.path))}
            <span
              className={`text-xs mt-1 ${
                isActive(tab.path) ? "text-sky-400 font-semibold" : "text-gray-500"
              }`}
            >
              {tab.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomNav;
